import { FormikHelpers } from "formik";
import { t } from "i18next";

export function isValidHttpUrl(str: string) {
  const pattern = new RegExp(
    "^(http(s)?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i"
  );
  return pattern.test(str);
}

export function getLabel(name: string) {
  return t(name) ?? name;
}

export function validateBeforeExecute(
  formik: any,
  action: any,
  handleContinueCondition?: () => boolean
) {
  formik.submitForm().then(() => {
    formik.validateForm().then(() => {
      if (
        formik.isValid &&
        (!handleContinueCondition || handleContinueCondition())
      ) {
        action();
      }
    });
  });
}
